import AOS from 'aos'
import Vue from 'vue'
import App from './App.vue'
import VueCarousel from '@chenfengyuan/vue-carousel'

import './assets/tailwind.css'
import './assets/styles/app.css';

import 'aos/dist/aos.css'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueCarousel);

Vue.mixin({
  data: function() {
    return {
      get globalAssetPath() {
        return process.env.VUE_APP_ASSETS_ROOT;
      }
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  created () {
    AOS.init({
      startEvent: 'load'
    })
  }
}).$mount('#app')
